<template>
  <el-card style="min-height: 480px" shadow="never">
    <div style="font-size: 14px; font-weight: bold; margin-bottom: 5px">
      环境控制
    </div>
    <div v-if="control.length == 0" style="font-size: 12px; color: #999">
      该地块尚未安装或配置控制设备
    </div>
    <el-row :gutter="5">
      <el-col
        :span="6"
        v-for="(item, index) in control"
        :key="item.id"
        style="margin-bottom: 12px"
      >
        <el-card shadow="never" :body-style="{ padding: '6px' }">
          <span style="font-size: 12px">{{ item.label }}</span>
          <div v-if="item.phase == 1">
            <el-radio-group
              size="mini"
              v-model="item.state"
              @change="open(item, index)"
              style="margin-bottom: 8px; margin-top: 5px"
            >
              <el-radio-button label="1">打开</el-radio-button>
              <el-radio-button label="0">停止</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="item.phase == 2">
            <el-radio-group
              size="mini"
              v-model="item.state"
              @change="open(item, index)"
              style="margin-bottom: 8px; margin-top: 5px"
            >
              <el-radio-button label="1">打开</el-radio-button>
              <el-radio-button label="0">停止</el-radio-button>
              <el-radio-button label="2">收起</el-radio-button>
            </el-radio-group>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import equipSetUrl from '@/common/equipSetUrl.js'
import {
  addControlDevice,
  updateControlDevice,
  delControlDevice,
} from '@/api/equip.js'
import { getControlDevice, ControlDevice } from '@/api/cloud.js'
import { searchUrl, changeControl, getEquipData,changeControlCMXZ } from '@/api/equipControl.js'
export default {
  name: 'control',
  // props: ['landId'],
  props: ['sn', 'landId'],
  data() {
    return {
      control: [],
      urlList: [],
      setControlFlg: true,

      form: {
        id: undefined,
        deviceName: '',
        sn: '',
        autoShutdownTime: '',
        route: '',
        address: '',
        switchOff: '',
        switchOn: '',
      },
      initSn: '',
      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
        ],
        sn: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        route: [{ required: true, message: '请输入线路', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        switchOff: [{ required: true, message: '请输入开值', trigger: 'blur' }],
        switchOn: [{ required: true, message: '请输入关值', trigger: 'blur' }],
      },
      mSn: '',
    }
  },
  mounted() {
    console.log('设备', this.control)
    this.initSn = this.mSn
  },
  methods: {
    setControl() {
      this.resetForm()
      this.setControlFlg = !this.setControlFlg
    },
    //控制开关
    open(item, index) {
      console.log('item', item)

      console.log('dikuai', this.landId)
      if (this.landId == 11 || this.landId == 33) {
        console.log('进入地块')
        if (item.label == '温度控制器') {
          console.log('进入温服控制')
          this.mSn = '34EAE71B030C'

          index = 0
        } else {
          this.mSn = this.initSn
        }
      }

      searchUrl(this.mSn).then((res) => {
        if (this.mSn.indexOf('cmxz') == -1) {
          this.baseUrl =
            'http://' + res.data.domain + '/api/relay-controller/' + index
          // '?of=relay&state='
          //   item.state+'&sn='+this.mSn
          // console.log('k', this.baseUrl)
          changeControl(this.baseUrl, item.state, this.mSn).then((res) => {
            console.log('发送成功')
          })
        } else {
          this.baseUrl1 =
            'http://' +
           res.data.domain +
            '/api/switching/' +
            this.mSn +
            '/' +
            index +
            '/' +
            item.state

          changeControlCMXZ(this.baseUrl1).then((res) => {
            console.log('发送成功')
          })
        }
      })
    },
    // controlDeviceGet(landId) {
    //   getControlDevice(this.landId).then((data) => {
    //     if (data.data) {
    //       this.control = data.data
    //     }
    //   })
    // },

    controlDeviceGet(sn) {
      this.initSn = sn
      this.mSn = sn
      searchUrl(sn).then((res) => {
        if (res.data.domain) {
          this.baseUrl =
            'http://' +
            res.data.domain +
            '/api/meta/switchable-items?sn=' +
            this.mSn
          // console.log('a', this.baseUrl)
          getEquipData(this.baseUrl).then((data) => {
            if (data) {
              data.forEach((element) => {
                element.state = 0
              })
              this.control = data
            }
          })
        } else {
          this.control = []
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/monitor/environment/MonitorControl.vue